// https://git.corpautohome.com/GP_RD_FE_S/am-scheme
// App Scheme 协议列表 #83664740

/**
 * 将 plain-object 转换为 url 地址参数
 *
 * @param {Object} args plain-object
 * @param {boolean} encoding 是否对参数编码
 * @returns {string} url 地址参数
 */
function param(args, encoding = false) {
  return `?${Object.keys(args)
    .map(key => `${key}=${!encoding ? args[key] : encodeURIComponent(args[key])}`)
    .join('&')
  }`;
}

/**
 * 获取 APP 信息
 *
 * @returns {string} isApp 是否在汽车之家 App 中打开
 * @returns {string} app_key app 平台 (iphone|android)
 * @returns {string} app_ver app 版本
 */
function getAppInfo() {
  const ua = navigator.userAgent;
  const co = document.cookie;
  const ur = /auto_(iphone|android)(;|%3B|\/)(\d+\.\d+\.\d+)/i;
  const cr = /.*app_key=auto_(iphone|android)(.*)app_ver=(\d+\.\d+\.\d+)/i;
  const isApp = /autohomeapp/.test(ua) || ur.test(ua) || cr.test(co);

  const match = ua.match(ur) || co.match(cr);
  const app_key = match && match[1];
  const app_ver = match && match[3];
  return { isApp, app_key, app_ver };
}

const scheme = 'autohome://';
const { isApp, app_key: appkey, app_ver: version } = getAppInfo();

/**
 * 与当前 APP 版本进行对比
 *
 * 无法获取当前版本 => NaN
 * app_ver > cmp_ver => 1
 * app_ver < cmp_ver => -1
 * app_ver === cmp_ver => 0
 *
 * @param {string} cmp_ver 版本字符串
 * @returns {number|boolean} 对比结果
 */
const compare = (cmp_ver) => {
  if (!version || !cmp_ver) {
    return NaN;
  }

  const pa = version.split('.');
  const pb = cmp_ver.split('.');

  for (let i = 0; i < 3; i += 1) {
    const na = Number(pa[i]);
    const nb = Number(pb[i]);
    if (na > nb) { return 1; }
    if (nb > na) { return -1; }
  }

  return 0;
};

function getUrl(path = '') {
  return `//${path ? `${path}.` : ''}m.autohome.com.cn/`;
}

const app = {
  appkey, version, compare,
  /**
   * 跳转 WebView #83666489
   *
   * @郝旭 20180408 新协议(wk)很早就有, 可以理解为几乎全量覆盖了
   * @param {string} url 完整的 https?/scheme 地址
   * @param {boolean} auto 是否去除协议头
   */
  insidebrowser(url, auto = true) {
    if (!url) { return ''; }

    // App 协议不支持 url 中带有空格
    const newUrl = url.replace(/\s/g, '');

    // url 也许是一个 scheme 地址
    if (newUrl.indexOf(scheme) !== -1 || !isApp || newUrl.indexOf('rninsidebrowser?') !== -1 || newUrl.indexOf('insidebrowserwk?') !== -1) {
      return newUrl;
    }

    // 判断 rn
    if (newUrl.indexOf('rn://') === 0) {
      return `${scheme}rninsidebrowser?url=${encodeURIComponent(newUrl)}`;
    }

    // m
    if (!appkey) {
      if (!auto) { return url; }
      return newUrl.replace(/https?:/, '');
    }

    // m 转化为 app 链接
    return `${scheme}insidebrowserwk?url=${encodeURIComponent(newUrl)}`;
  },

  /**
   * 视频最终页 #83664742
   *
   * autohome://article/videodetail?newsid=XX
   * v.m.autohome.com.cn/v-XX.html
   * @param {Object} args 视频数据
   * @param {number} args.newsid 视频id
   */
  videoDetail(args) {
    if (!appkey) {
      return `${getUrl('v')}v-${args.newsid}.html`;
    }

    return `${scheme}article/videodetail${param(args)}`;
  },

  /**
   * 文章最终页 #83664742
   *
   * autohome://article/articledetail?newsid=xxx&newstype=xxx
   * m.autohome.com.cn/drive/date/newsid.html / date会自动跳转
   * @param {Object} args 文章数据
   * @param {string} args.url https? 地址
   * @param {number} args.newsid 文章id
   * @param {number} args.newstype 文章类型（0普通, 1行情）
   */
  articleDetail({ url, ...args }) {
    if (!appkey) {
      return url.replace(/www/, 'm').replace(/https?:/, '');
    }

    return `${scheme}article/articledetail${param({ newstype: 0, ...args })}`;
  },

  // /**
  //  * 帖子列表页 #83664745
  //  *
  //  * autohome://club/topiclist?bbsid=123&bbsname=alsdf&bbstype=c&seriesid=1123
  //  * club.m.autohome.com.cn/bbs/forum-bbstype-bbsid-1.html
  //  * @param {Object} args 帖子列表数据
  //  * @param {number} args.bbsid 论坛id
  //  * @param {string} args.bbstype 论坛类型 c|a|o
  //  * @param {string} args.bbsname 论坛名称
  //  * @param {number} args.seriesid 车系id
  //  */
  // topicList(args) {
  //   if (!appkey) {
  //     return `${getUrl('club')}bbs/forum-${args.bbstype}-${args.bbsid}-1.html`;
  //   }

  //   return `${scheme}club/topiclist${param(args)}`;
  // },

  // /**
  //  * 帖子最终页 #83664745
  //  *
  //  * autohome://club/topicdetail?isask=0&pageid=72057737&bbsid=159&bbstype=c&title=
  //  * club.m.autohome.com.cn/bbs/thread-c-66-72629243-1.html
  //  * @param {Object} args 帖子数据
  //  * @param {number} args.pageid 帖子id
  //  * @param {number} args.bbsid 论坛id
  //  * @param {string} args.bbstype 论坛类型 c|a|o
  //  * @param {string} args.title 帖子标题
  //  * @param {number} args.isask 是否为问答帖
  //  */
  // topicDetail(args) {
  //   if (!appkey) {
  //     return `${getUrl('club')}bbs/thread-${args.bbstype}-${args.bbsid}-${args.pageid}-1.html`;
  //   }

  //   return `${scheme}club/topicdetail${param({ isask: 0, ...args })}`;
  // },

  // /**
  //  * 车系口碑列表页 #83665462
  //  *
  //  * autohome://reputation/reputationlist?seriesid=xxx&specid=xxx&seriesName=xxx&specname=xxxx
  //  * k.m.autohome.com.cn/442/?def=61248
  //  * @param {Object} args 口碑数据
  //  * @param {number} args.specid 车型id
  //  * @param {number} args.seriesname 车系名称
  //  * @param {string} args.seriesid 车系id
  //  * @param {string} args.summarykey 语义标签id
  //  * @param {number} args.categoryid 口碑一级维度分类对应id（综合, 空间, 动力等）
  //  */
  // reputationList(args) {
  //   if (!appkey) {
  //     const def = args.summarykey ? `?def=${args.summarykey}` : '';
  //     return `${getUrl('k')}${args.seriesid}/${def}`;
  //   }

  //   return `${scheme}reputation/reputationlist${param(args)}`;
  // },

  // /**
  //  * 口碑最终页 #83665462
  //  *
  //  * autohome://reputation/reputationdetail?seriesid=xxx&specid=xxx&koubeiid=xxx&seriesname={utf8string}
  //  * k.m.autohome.com.cn/spec/32457/view_1908149_1.html
  //  * @param {Object} args 口碑数据
  //  * @param {number} args.specid 车型id
  //  * @param {string} args.seriesname 车系名称
  //  * @param {number} args.seriesid 车系id
  //  * @param {string} args.koubeiid 口碑id
  //  */
  // reputationDetail(args) {
  //   if (!appkey) {
  //     return `${getUrl('k')}spec/${args.specid}/view_${args.koubeiid}_1.html`;
  //   }

  //   return `${scheme}reputation/reputationdetail${param(args)}`;
  // },

  /**
   * 车系综述页  #83664747
   * App 820 版本开始支持, 半年前发布的
   * autohome://car/seriesmain?seriesid=XX
   * https://m.autohome.com.cn/seriesid
   * @param {Object} args { seriesid : xx, option: xx }
   * @param {number} args.seriesid 车系id
   * @param {number} args.option 1 收藏 2 取消收藏 (触发同步）v9.12.0 开始支持
   */
  seriesMain(args) {
    if (!appkey && args.seriesid) {
      return `${getUrl()}${args.seriesid}`;
    }

    return `${scheme}car/seriesmain${param(args)}`;
  },

  /**
   * 车友圈详情页 #82521589
   *
   * autohome://CarFriend/CarFansDetail?isenablechat=1&socialid=xxx
   * club.m.autohome.com.cn/cyq/details-socialid.html
   * @param {Object} args 车友圈详情数据
   * @param {number} args.isenablechat 默认传1 可以直接从此页面进入聊天页面
   * @param {number} args.socialid 车友圈id
   */
  fansDetail(args) {
    if (compare('9.0.5') > 0 || appkey === 'android') {
      return `${scheme}carfriend/carfansdetail${param({
        isenablechat: 1, ...args,
      })}`;
    }

    if (compare('8.5.5') > 0) {
      return `${scheme}CarFriend/CarFansDetail${param({
        isenablechat: 1, ...args,
      })}`;
    }

    return this.insidebrowser(`https:${getUrl('club')}cyq/details-${args.socialid}.html`);
  },

}
export default app;